<template lang="html">
  <action-bar>
    <!-- Left -->
    <template slot="left">
      <!-- Back -->
      <div class="mr3">
        <router-link to="/" class="no-underline">
          <v-btn
            label="Back to list"
            icon-code="keyboard_arrow_left"
            icon-pos="left"
            icon-class="f5 b mt1"
            class="bg-transparent hover-action f6 b font-futura"
          />
        </router-link>
      </div>
      <!-- Download PDF -->
      <a :href="baseUrl + pdf.url" target="_blank" download class="no-underline">
        <v-btn
          label="Save PDF"
          icon-code="picture_as_pdf"
          icon-pos="left"
          class="bg-transparent hover-action f6 b font-futura"
          v-if="!isTouchscreen"
        />
      </a>

      <!-- Email Floor plan -->
      <a @click="showEmailModal(true)">
        <v-btn
          label="Email Floorplan"
          icon-code="email"
          icon-pos="left"
          class="bg-transparent hover-action f6 b font-futura"
          v-if="isTouchscreen"
        />
      </a>

    </template>

    <!-- Right -->
    <template slot="right">
      <router-link to="/" class="no-underline">
        <v-btn @click.native="SET_VIEWING_FAVOURITES(true)"
          :label="favouritesCount"
          icon-code="star"
          icon-pos="left"
          icon-class="f4"
          class="interact-bg-favourite raise b font-futura-bold"
        />
      </router-link>
    </template>
  </action-bar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ButtonComponent from '@/components/Button';
import ActionBar from '@/components/ActionBar';
import FloorplanMixin from '../FloorplanMixin';

export default {
  name: 'floorplan-detail-actions',
  components: {
    'v-btn': ButtonComponent,
    'action-bar': ActionBar
  },
  props: {
    pdf: {
      type: Object,
      default: () => ({})
    }
  },
  mixins: [FloorplanMixin],
  computed: {
    ...mapGetters([
      'isTouchscreen',
      'favourites',
      'floorplans'
    ]),
    favouritesCount() {
      const favouritesCount = this.favourites.length;
      return favouritesCount.toString();
    }
  },
  methods: {
    ...mapActions([
      'SET_VIEWING_FAVOURITES',
      'SET_EMAIL_LIST',
      'TOGGLE_EMAIL_FLOORPLANS'
    ]),
    showEmailModal(status) {
      const currentPlan = this.floorplans.find(plan => plan.id === this.$route.params.id);
      this.SET_EMAIL_LIST([currentPlan]);
      this.TOGGLE_EMAIL_FLOORPLANS(status);
    }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanDetail/FloorplanDetailActions.vue